import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_FLEET_RESERVATIONS = createActionTypes('FETCH_FLEET_RESERVATIONS');
export const GET_FLEET_RESERVATION = createActionTypes('GET_FLEET_RESERVATION');
export const CHECK_FLEET_RESERVATION_AVAILABILITY = createActionTypes('CHECK_FLEET_RESERVATION_AVAILABILITY');
export const CREATE_FLEET_RESERVATION = createActionTypes('CREATE_FLEET_RESERVATION');
export const RESCHEDULE_FLEET_RESERVATION = createActionTypes('RESCHEDULE_FLEET_RESERVATION');
export const CANCEL_FLEET_RESERVATION = createActionTypes('CANCEL_FLEET_RESERVATION');
